import { pushPage } from "./pageHistory";

// Starts a new page in the browser history with the current state
const pushNextPage = (state) => pushPage(state);

export default pushNextPage;
